import { render, staticRenderFns } from "./OwnerNew.vue?vue&type=template&id=bae12a12&scoped=true&"
import script from "./OwnerNew.vue?vue&type=script&lang=js&"
export * from "./OwnerNew.vue?vue&type=script&lang=js&"
import style0 from "./OwnerNew.vue?vue&type=style&index=0&id=bae12a12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bae12a12",
  null
  
)

export default component.exports